import React from "react";
import classnames from "classnames";

import AlertIcon from "components/Icons/alert.svg";
import CheckIcon from "components/Icons/check_mark.svg";
import ClearIcon from "components/Icons/x.svg";

type Props = {
  message: string;
  isFilled: boolean;
  size: string;
  className: string;
  icon?: string;
  dismissable?: boolean;
};

export const NotificationSize = Object.freeze({
  LARGE: "large",
  SMALL: "small",
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const iconSizes: any = Object.freeze({
  large: [24, 24],
  small: [16, 16],
});

const Notification = ({
  message,
  isFilled,
  size = NotificationSize.LARGE,
  className,
  icon = "warn",
  dismissable = false,
}: Props) => {
  const classes = classnames(
    "flex items-center z-10 rounded px-md bg-white",
    className,
    {
      "border bg-yellow-20 border-yellow-60": isFilled,
      "py-lg text-default": size === NotificationSize.LARGE,
      "py-sm text-xs": size === NotificationSize.SMALL,
    },
  );

  const [width, height] = iconSizes[size];
  const [showNotification, setShowNotification] = React.useState(true);
  const onCloseClick = () => setShowNotification(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  const iconMap: any = {
    check: (
      <CheckIcon
        width={width}
        height={height}
        className="text-green flex flex-shrink-0"
      />
    ),
    warn: (
      <AlertIcon
        width={width}
        height={height}
        className="text-yellow flex flex-shrink-0"
      />
    ),
  };

  return showNotification ? (
    <React.Fragment>
      <style jsx>{`
        .toast {
          position: absolute;
          top: 30px;
          right: 15px;
          left: 15px;
        }
        @media (min-width: 768px) {
          .toast {
            position: absolute;
            top: 30px;
            right: 0px;
            left: 0px;
          }
        }
      `}</style>
      <div className={classes}>
        {icon && iconMap[icon]}
        <div className="ml-md mr-md flex-grow">{message}</div>
        {dismissable && (
          <button aria-label="dismiss notification" onClick={onCloseClick}>
            <ClearIcon height="16" width="16" className="flex flex-shrink-0" />
          </button>
        )}
      </div>
    </React.Fragment>
  ) : null;
};

export default Notification;
